import type { FC } from 'react';
import { Flex } from '@chakra-ui/react';
import { FormattedMessage } from 'react-intl';
import { Button, Modal, Text } from '../../../ui-components';
import { Field } from '../../field';
import type { FieldConfig } from '../../field';

interface SubmitQuestionModalProps {
    id: string;
    isOpen: boolean;
    title: string;
    fields: Record<string, FieldConfig>;
    headerText: string | React.ReactNode;
    onClose: () => void;
    onSubmit: () => void;
    onSkip?: () => void;
    variant?: string;
}

export const SubmitQuestionModal: FC<SubmitQuestionModalProps> = ({
    id,
    isOpen,
    fields,
    onClose,
    onSubmit,
    onSkip,
    title,
    headerText,
    variant,
}) => (
    <Modal id={id} title={title} isOpen={isOpen} onClose={onClose} variant={variant}>
        <Text id={`${id}-description`}>{headerText}</Text>
        <Flex marginTop={8}>
            <Field {...fields.firstName} />
        </Flex>
        <Flex marginTop={8}>
            <Field {...fields.lastName} />
        </Flex>
        <Flex marginTop={8}>
            <Field {...fields.email} />
        </Flex>
        <Flex marginTop={8}>
            <Field {...fields.nickName} />
        </Flex>
        <Button
            id={`${id}-apply-button`}
            variant="primary-black"
            onClick={onSubmit}
            margin="28px 0 24px 0"
        >
            <FormattedMessage id="submit" defaultMessage="Submit" />
        </Button>
        {onSkip && (
            <Flex marginTop={6} marginBottom={6}>
                <Button variant="text-button-no-hover" onClick={onSkip}>
                    <Text size="small">
                        <FormattedMessage
                            id="turn-to.question-modal.skip-details"
                            defaultMessage="Skip, I don't want answers emailed to me"
                        />
                    </Text>
                </Button>
            </Flex>
        )}
    </Modal>
);
